import React from 'react';
import classnames from 'classnames';
import get from 'lodash.get';

import CardBody from '../CardBody';
import { CardBodyProps } from '../CardBody/CardBody';

import CardWrapper from '../CardWrapper';
import { CardWrapperProps } from '../CardWrapper/CardWrapper';

export enum MAP_CLASSES {
  primary = 'card--primary',
  secondary = 'card--secondary',
  tertiary = 'card--tertiary',
  transparent = 'card--transparent',
  background = 'card--background'
}

export type CardVariants =
  | 0
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'transparent'
  | 'background';

export interface CardProps extends React.HTMLAttributes<HTMLElement> {
  cardBodyFullWidth?: boolean;
  variant?: CardVariants;
  imgSrc?: string;
  cardBodyProps?: CardBodyProps; // TODO: use cardbodyProps
  cardWrapperProps?: CardWrapperProps;
}

const Card: React.FunctionComponent<CardProps> = ({
  cardBodyFullWidth = false,
  cardBodyProps,
  cardWrapperProps,
  children,
  imgSrc,
  variant = 0
}) => {
  const cardWrapperClasses = classnames(
    MAP_CLASSES[variant],
    get(cardWrapperProps, 'className')
  );

  const cardWrapperStyles = get(cardWrapperProps, 'style') || {};
  const imgSrcStyle =
    MAP_CLASSES[variant] === MAP_CLASSES.background && imgSrc
      ? { backgroundImage: `url('${imgSrc}')` }
      : {};

  return (
    <CardWrapper
      {...cardWrapperProps}
      className={cardWrapperClasses}
      style={{
        ...cardWrapperStyles,
        ...imgSrcStyle
      }}
    >
      <CardBody fullWidth={cardBodyFullWidth} {...cardBodyProps}>
        {children}
      </CardBody>
    </CardWrapper>
  );
};

export default Card;
